import { render } from "./App.vue?vue&type=template&id=e965e89c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=e965e89c&lang=css"

import exportComponent from "C:\\Users\\SebastiánContreras\\OneDrive - Defensoría del Contribuyente\\Documents\\INGENIERIA DESARROLLO_TI\\REPOSITORIO_PROYECTOS\\AUTENTIFICACION_FRONTEND\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__